<template>
  <div class="row">
    <div class="container">
      <div class="main">
        <div v-if="customers.length > 1" class="container list-clients">
          <h2>SELEÇÃO DE CNPJ</h2>
          <div class="content">
            <p class="list-label">
              Serão exibidos os boletos de todos os clientes selecionados
              abaixo:
            </p>
            <div
              v-for="customer in customers"
              :key="customer.code"
              class="list"
            >
              <div class="checkbox-wrapper">
                <input
                  type="checkbox"
                  v-model="selectedCustomers"
                  :value="customer.cnpj"
                  class="checkbox"
                />
              </div>
              <div class="customer">
                <span><b>Cliente:</b> {{ maskCNPJ(customer.cnpj) }} - {{ customer.name }} </span>
                <span><b>Código:</b> {{ customer.code }}</span>
                <span><b>Endereço:</b> {{ customer.address }} </span>
              </div>
            </div>
          </div>
        </div>

        <button 
          v-if="customers.length > 1" 
          @click="searchTickets" 
          class="btn" 
          :disabled="loading" >
          <i class="fa fa-search"></i>
          <span>BUSCAR BOLETOS</span>
        </button>

        <div v-if="loading && customers.length > 1" class="loading-overlay">
          <div class="loading-content">
            <span>({{ `${completed}/${total}` }})</span>
            <p>
              Isso pode levar alguns instantes...<br />Aguarde até a busca ser
              finalizada!
            </p>
            <div class="loader"></div>
          </div>
        </div>
        <div class="loading-one-custumer" v-else-if="loading">
          <p>
            Isso pode levar alguns instantes...<br />Aguarde até a busca ser
            finalizada!
          </p>
          <div class="loader"></div>
        </div>

        <div class="filters" v-if="tickets.length > 0">
          <c-busca
            :fieldsProp="fieldsSearch"
            @changeFiltros="changeFilters"
          ></c-busca>

          <v-lt-tickets
            :tickets="this.tickets"
            :customers="this.customers"
            :accessToken="this.accessToken"
            ref="listagem"
          ></v-lt-tickets>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import "flatpickr/dist/plugins/monthSelect/style.css";

const DEFAULT_FIELDS_SEARCH = [
  {
    name: "our_number",
    type: "text",
    label: "Nosso Número",
    class: "column-2",
    value: "",
  },
  {
    name: "document_number",
    type: "text",
    label: "Número do Documento",
    class: "column-2",
    value: "",
  },
  {
    name: "value",
    type: "text",
    label: "Valor",
    class: "column-2",
    value: "",
  },
  {
    name: "due_date",
    type: "date",
    label: "Vencimento Data",
    class: "column-2",
    value: "",
    flatConfig: {
      disableMobile: true,
      locale: Portuguese,
      plugins: [
        monthSelectPlugin({
          shorthand: true,
          dateFormat: "m/Y",
          altFormat: "F Y",
        }),
      ],
    },
    flatClear: true,
  },
];

export default {
  name: "segunda-via-boleto",
  props: {
    customers: [Array],
    accessToken: String,
  },
  data() {
    return {
      selectedCustomers: [],
      tickets: [],
      loading: false,
      total: 0,
      completed: 0,
      fieldsSearch: DEFAULT_FIELDS_SEARCH,
    };
  },
  mounted() {
    if (this.customers.length == 1) {
      this.selectedCustomers = [this.customers[0].cnpj];
      this.searchTickets();
    }
  },
  methods: {
    async searchTickets() {
      if (this.selectedCustomers.length == 0) {
        this.$fire({
            text: 'Por favor, selecione ao menos um cliente.',
            type: 'info',
            confirmButtonText: 'OK',
            allowOutsideClick: true,
        })
        return;
      }

      this.loading = true;
      this.total = this.selectedCustomers.length;
      this.completed = 0;

      try {
        this.tickets = [];
        
        let promises = this.selectedCustomers.map((cnpj) => {
          return this.getTicket(cnpj);
        });

        let result = await Promise.all(promises);

        this.tickets = result.flat().sort((a, b) => {
          const dateA = moment(a.due_date, "DD/MM/YYYY");
          const dateB = moment(b.due_date, "DD/MM/YYYY");

          return dateA - dateB; // Ascending order
        });

        if (!this.tickets.length) {
          document.getElementById("second-copy").style.display = "none";
          document.getElementById("message-empty").style.display = "block";
        }
      } catch (error) {
        if (error) {
          document.getElementById("second-copy").style.display = "none";
          document.getElementById("message-error").style.display = "block";
        }
      } finally {
        if (this.customers.length > 1) {
          const oldFieldsSearch = this.fieldsSearch;

          this.fieldsSearch = [
            {
              name: "cnpj",
              type: "text",
              label: "CNPJ",
              class: "column-2",
              value: "",
            },
            {
              name: "name",
              type: "text",
              label: "Razão Social",
              class: "column-2",
              value: "",
            },
            ...DEFAULT_FIELDS_SEARCH,
          ];
        }

        this.loading = false;
      }
    },
    async getTicket(cnpj) {
      const URL = NEW_API_URL;

      try {
        const customer = this.customers.find((c) => c.cnpj === cnpj);

        const response = await this.axios.get(
          URL + "/api/my-orders/my-orders-customers/bank-slips",
          {
            params: { cnpj: cnpj },
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.accessToken}`,
            },
          }
        );

        this.completed++;

        this.$nextTick(() => {
          this.$forceUpdate();
        });

        if (response && response.data) {
          return response.data.data.bank_slips.map((item) => {
            return {
              cnpj: this.maskCNPJ(cnpj),
              name: customer.name,
              amount: item.amount,
              our_number: item.our_number,
              document_number: item.document_number,
              value: item.amount,
              due_date: item.due_date.replace(/-/g, "/"),
              download_key: item.download_key,
            };
          });
        } else {
          return;
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    changeFilters(filtros) {
      this.$refs.listagem.search(Object.assign({}, ...filtros));
    },
    maskCNPJ(cnpj) {
      return cnpj.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        "$1.$2.$3/$4-$5"
      );
    },
  },
};
</script>
